module.exports = __webpack_public_path__ + "files/d9162dfe8f36db18b8d4ef7ffa75692d.ttf";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/katex/dist/fonts/KaTeX_Main-Regular.ttf
// module id = 1663
// module chunks = 60